import React, {Component} from 'react';
import UserApi from "../../api/UserApi";

class SignOutButton extends Component {
  onLogoutClick() {
    UserApi.logout();
  }

  render() {
    return (
      <button className={this.props.className} onClick={this.onLogoutClick.bind(this)}>
        {this.props.children || "Logout"}
      </button>
    );
  }
}

export default SignOutButton;